const { setInitialised } = window.BAO.Carousel.plugins

class PushCartRecommendedProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()

    this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.75,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 3.2,
              spacing: 20,
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('push-cart-recommended-products')) {
  customElements.define(
    'push-cart-recommended-products',
    PushCartRecommendedProducts,
  )
}
